module.exports = __webpack_public_path__ + "static/media/FB5-4_FB6-2_blop-human-pop.a553ef5c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/FB5-4_FB6-2_blop-human-pop.wav
// module id = 863
// module chunks = 0